import React from 'react';
import { motion } from 'framer-motion';

// Import all device icons
import android from '../assets/icons/device/Android.png';
import hisense from '../assets/icons/device/Hisense.png';
import lenovo from '../assets/icons/device/Lenovo.png';
import vizio from '../assets/icons/device/VIZIO.png';
import windows from '../assets/icons/device/Windows.png';
import androidtv from '../assets/icons/device/androidtv.png';
import apple from '../assets/icons/device/apple.png';
import chrome from '../assets/icons/device/chrome.png';
import firetv from '../assets/icons/device/firetv.png';
import formuler from '../assets/icons/device/formuler.png';
import huawei from '../assets/icons/device/huawei.png';
import lg from '../assets/icons/device/lg.png';
import philips from '../assets/icons/device/philips.png';
import roku from '../assets/icons/device/roku.png';
import samsung from '../assets/icons/device/samsung.png';
import sharp from '../assets/icons/device/sharp.png';
import sony from '../assets/icons/device/sony.png';
import tcl from '../assets/icons/device/tcl.png';
import toshiba from '../assets/icons/device/toshiba.png';
import x96 from '../assets/icons/device/x96.png';
import xiaomi from '../assets/icons/device/xiaomi.png';

const devices = [
    { name: 'Android', icon: android },
    { name: 'Apple', icon: apple },
    { name: 'Windows', icon: windows },
    { name: 'Samsung', icon: samsung },
    { name: 'LG', icon: lg },
    { name: 'Sony', icon: sony },
    { name: 'Android TV', icon: androidtv },
    { name: 'Fire TV', icon: firetv },
    { name: 'Roku', icon: roku },
    { name: 'Chrome', icon: chrome },
    { name: 'Hisense', icon: hisense },
    { name: 'TCL', icon: tcl },
    { name: 'Philips', icon: philips },
    { name: 'Toshiba', icon: toshiba },
    { name: 'Xiaomi', icon: xiaomi },
    { name: 'Huawei', icon: huawei },
    { name: 'Lenovo', icon: lenovo },
    { name: 'Vizio', icon: vizio },
    { name: 'Formuler', icon: formuler },
    { name: 'Sharp', icon: sharp },
    { name: 'X96', icon: x96 },
];

const container = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.05
        }
    }
};

const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
};

export default function DevicesSection() {
    return (
        <section className="py-20 relative overflow-hidden">
            {/* Background Elements */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 -left-64 w-96 h-96 bg-yellow-400/10 rounded-full blur-[100px]"></div>
                <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-blue-500/10 rounded-full blur-[100px]"></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                    <motion.h2 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6"
                    >
                        Compatible con <span className="text-yellow-400">todos sus dispositivos</span>
                    </motion.h2>
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.1 }}
                        className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto"
                    >
                        Disfrute de su suscripción IPTV en cualquier pantalla. Ya sea en casa o en movimiento, TVSOLA le sigue a todas partes.
                    </motion.p>
                </div>

                <motion.div 
                    variants={container}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true }}
                    className="grid grid-cols-[repeat(3,auto)] sm:grid-cols-[repeat(4,auto)] md:grid-cols-[repeat(5,auto)] lg:grid-cols-[repeat(7,auto)] justify-center gap-4 md:gap-6"
                >
                    {devices.map((device, index) => (
                        <motion.div
                            key={index}
                            variants={item}
                            whileHover={{ scale: 1.05, y: -5 }}
                            className="flex flex-col items-center justify-center group"
                        >
                            <div className="w-20 h-16 md:w-24 md:max-h-16 bg-white/5 backdrop-blur-sm rounded-2xl py-4 px-3  flex items-center justify-center border border-white/10 group-hover:bg-white/10 group-hover:border-yellow-400/30 transition-all duration-300 shadow-lg group-hover:shadow-yellow-400/10">
                                <img 
                                    src={device.icon} 
                                    alt={device.name} 
                                    className="w-full h-full object-contain filter brightness-0 invert group-hover:filter-none group-hover:brightness-110 transition-all duration-300"
                                />
                            </div>

                        </motion.div>
                    ))}
                </motion.div>

                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5 }}
                    className="mt-16 text-center"
                >
                    <div className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 border border-white/10 text-gray-300 text-sm md:text-base">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-yellow-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        </svg>
                        <span>Configuración simple y rápida en todos los dispositivos</span>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
